import { HEIGHT, WIDTH } from './constants'

// ⚠️ A first `new RTCPeerConnection` or `getCapabilities` blocks ~1.2 s on encoder enumeration that `encodingInfo` awaits off the main thread.
const H264 = 'video/H264; profile-level-id=42e01f; packetization-mode=1'

let check

/**
 * Check if browser supports H264 encoding (Baseline preferred, High also accepted) Required for WebRTC communication with the server. One check per page.
 */
export const checkH264Support = () => (check ??= probeH264())

async function probeH264() {
	if (typeof RTCRtpSender === 'undefined' || !RTCRtpSender.getCapabilities) {
		return { supported: false, reason: 'WebRTC not supported' }
	}

	try {
		const { supported } = await navigator.mediaCapabilities.encodingInfo({
			type: 'webrtc',
			video: { contentType: H264, width: WIDTH, height: HEIGHT, bitrate: 2_000_000, framerate: 30 },
		})
		return { supported, reason: supported ? null : 'H264 not available' }
	} catch {
		// No `webrtc` type in mediaCapabilities: the blocking read.
	}

	const caps = RTCRtpSender.getCapabilities('video')
	const h264Codecs = caps.codecs.filter(c => c.mimeType === 'video/H264')

	return {
		supported: h264Codecs.length > 0,
		profiles: h264Codecs.map(c => c.sdpFmtpLine),
		reason: h264Codecs.length > 0 ? null : 'H264 not available',
	}
}

window.check264 = checkH264Support
